export default {
  询比价管理列表: "詢比價管理列表",
  新增询价: "新增詢價",
  保存成功: "保存成功",
  请添加询价物料: "請添加詢價物料",
  请添加询价物料名称: "請添加詢價物料名稱",
  请添加供应商: "請添加供應商",
  询价基本信息: "詢價基本資訊",
  询价类型: "詢價類型",
  请选择询价类型: "請選擇詢價類型",
  询价单标题: "詢價單標題",
  请输入询价单标题: "請輸入詢價單標題",
  截止时间: "截止時間",
  请选择截止时间: "請選擇截止時間",
  询价明细: "詢價明細",
  搜索物料: "搜尋物料",
  添加物料行: "添加物料行",
  序号: "序號",
  物料编号: "物料編號",
  "物料名称（中文）": "物料名稱（中文）",
  "物料名称（英文）": "物料名稱（英文）",
  "商品名称（如有）": "商品名稱（如有）",
  药典: "藥典",
  标准: "標準",
  数量: "數量",
  数量单位: "數量單位",
  备注: "備註",
  请输入: "請輸入",
  材料结构: "材料結構",
  尺寸: "尺寸",
  其他要求: "其他要求",
  类别: "類別",
  物料代号: "物料代號",
  物料名称: "物料名稱",
  "CAS No. | Catalogue No.（供应商目录号）":
    "CAS No. | Catalogue No.（供應商目錄號）",
  "建议包装规格（如：25kg/袋）": "建議包裝規格（如：25kg/袋）",
  "备注(品牌/等级要求）": "備註(品牌/等級要求）",
  供应商选择: "供應商選擇",
  共count个供应商: "共{count}個供應商",
  清空: "清空",
  从供应商库选择: "從供應商庫選擇",
  暂无供应商: "暫無供應商",
  全選: "全選",
  未命名供應商: "未命名供應商",
  "绑定需求申請單(如有)": "綁定需求申請單(如有)",
  添加: "添加",
  询价单号: "詢價單號",
  询价状态: "詢價狀態",
  标题: "標題",
  创建人: "創建人",
  创建时间: "創建時間",
  截止日期: "截止日期",
  报价进度: "報價進度",
  操作: "操作",
  比价: "比價",
  询价单基本信息: "詢價單基本資訊",
  导出: "導出",
  询价单编号: "詢價單編號",
  物料类型: "物料類型",
  询价日期: "詢價日期",
  关联需求单: "關聯需求單",
  询价单要求明细: "詢價單要求明細",
  目标供应商数量: "目標供應商數量",
  已报价供应商数量: "已報價供應商數量",
  "最低报价（总价）": "最低報價（總價）",
  "最高报价（总价）": "最高報價（總價）",
  物料index: "物料{index}",
  导出当前物料: "導出當前物料",
  比价单: "比價單",
  价格对比: "價格對比",
  更多明细: "更多明細",
  该供应商未填写报价: "該供應商未填寫報價",
  查看更多: "查看更多",
  供应商名称: "供應商名稱",
  总价: "總價",
  单价: "單價",
  货币: "貨幣",
  最低起订量: "最低起訂量",
  国际贸易条款: "國際貿易條款",
  交货期: "交貨期",
  产地: "產地",
  发货地点: "發貨地點",
  是否含运费: "是否含運費",
  是: "是",
  否: "否",
  备注说明: "備註說明",
  单位HKD: "單位：HKD",
  填报明细: "填報明細",
  报名截止日期: "報名截止日期：",
  提交成功: "提交成功",
  总结: "總結",
  请输入总结: "請輸入總結",
  返回: "返回",
  品牌: "品牌",
  产品货號: "產品貨號",
  等级: "等級",
  产品名称: "產品名稱",
  规格: "規格",
  单位: "單位",
  折扣: "折扣",
  "交货期/天": "交貨期/天",
  最小包装规格: "最小包裝規格",
  物料文件: "物料文件",
  样品测试情况: "樣品測試情況",
  是否符合澳美的物料信息: "是否符合澳美的物料資訊",
  关闭: "關閉",
  暂存: "暫存",
  发送询价: "發送詢價",
};
